import { render, staticRenderFns } from "./ChatbotChat.vue?vue&type=template&id=3ff7aa13&scoped=true"
import script from "./ChatbotChat.vue?vue&type=script&lang=js"
export * from "./ChatbotChat.vue?vue&type=script&lang=js"
import style0 from "./ChatbotChat.vue?vue&type=style&index=0&id=3ff7aa13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff7aa13",
  null
  
)

export default component.exports